import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const StyledLink = styled(Link)`
  color: var(--color-accent);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
